import type { FireAnalyticsEvent } from '../../types';

import type { CommonAttributes } from './types';

type ErrorBoundaryHitAnalyticsProps = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: Record<string, any>;
	failSection: string;
};

export const onErrorBoundaryHit = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	failSection,
}: ErrorBoundaryHitAnalyticsProps): FireAnalyticsEvent => {
	return {
		eventType: 'track',
		source: failSection,
		actionSubject: 'searchPageErrorBoundary',
		action: 'failed',
		attributes: {
			commonAttributes,
		},
		nonPrivacySafeAttributes,
	};
};
